import { IBaseAction } from '../useAction';
import { IFlexNavigation } from '../flex/useFlexNavigation';
import { IView } from '../../views/view';
import useNavigation from '../useNavigation';

export interface IOnfidoAction extends IBaseAction {
  type: 'start_onfido_flow';
  data: {
    sdkToken: string;
    includeFacialUpload: boolean;
    includeDocumentUpload: boolean;
    completionNavigation: IFlexNavigation;
  };
}

const useOnfidoAction = () => {
  const navigation = useNavigation();

  const handleOnfidoAction = (action: IOnfidoAction) => {
    const newView: IView = {
      type: 'ONFIDO',
      source: {
        sdkToken: action.data.sdkToken,
        includeFacialUpload: action.data.includeFacialUpload,
        includeDocumentUpload: action.data.includeDocumentUpload,
        onCompleteNav: action.data.completionNavigation,
        entryIndex: window.history.length,
      },
    };
    navigation.replace(newView);
  };

  return handleOnfidoAction;
};

export default useOnfidoAction;
